export const DETAIL_STATE = {
    ITEM: 'item',
    SPELL: 'spell',
    SKILL: 'skill',
    POLYMORPH: 'polymorph',
    MAGICDOLLS: 'magicdolls',
};